import { createSlice, type PayloadAction, type SliceSelectors } from '@reduxjs/toolkit'
import type { ModalShowAction } from '../actions/modalActions/showModal'
import type { RootState } from '../configureStore'

type ModalState = {
  modal:
    | ModalShowAction['payload']
    | {
        modalShown: ''
        modalPayload: null
      }
}

const getInitialState = (): ModalState => ({
  modal: { modalShown: '', modalPayload: null },
})

export const modalSlice = createSlice<
  ModalState,
  {
    clearModal(state: ModalState): void
    showModal(state: ModalState, action: { type: string; payload: ModalShowAction['payload'] }): void
  },
  'modal',
  SliceSelectors<ModalState>,
  'modal'
>({
  name: 'modal',
  initialState: getInitialState(),
  reducers: {
    clearModal(state) {
      state.modal = { modalShown: '', modalPayload: null }
    },
    showModal(state, action: PayloadAction<ModalShowAction['payload']>) {
      state.modal = action.payload
    },
  },
})

export const { showModal, clearModal } = modalSlice.actions

export const selectModal = (state: RootState) => state.modal.modal
